import type { SwInboundMessage } from "~/helpers/sw/messageContract";

import logger from "~/helpers/logger";

// The controller path is synchronous so a message survives an immediately following navigation.
const postToServiceWorker = (message: SwInboundMessage): void => {
	if (!("serviceWorker" in navigator)) return;
	const controller = navigator.serviceWorker.controller;
	if (controller) {
		controller.postMessage(message);
		return;
	}
	navigator.serviceWorker.ready
		.then((registration) => registration.active?.postMessage(message))
		.catch((err) => logger.error("[sw] failed to post message to service worker", err, { type: message.type }));
};

export default postToServiceWorker;
